function initSliderFor(sectionSelector, overrides = { sliderOverrides: { autoplay: false } }) {
  let { sliderOverrides } = overrides;
  let autoplay = sliderOverrides?.autoplay === false ? false : true;

  if (sliderOverrides) sliderOverrides.autoplay = false;

  $(document).ready(function () {
    let sliderContainer = $(sectionSelector).find(`[class$="-slider"]`);
    let slider = sliderContainer.find(`[class$="-slider-w"]`);
    let sliderDotsContainer = sliderContainer.find(`[class$="-slider-p-d-w"]`);
    let sliderArrowsContainer = sliderContainer.find(`[class$="-slider-p-b-w"]`);

    // Create dots container if doesn't exist
    if (!sliderDotsContainer.length) {
      let sliderDotsContainerHTML = `
            <div class="element-slider-p">
                <div class="element-slider-p-d-w"></div>
                <div class="element-slider-p-b-w"></div>
            </div>`;
      let sliderDotsWrapper = $(sliderDotsContainerHTML);
      slider.after(sliderDotsWrapper);

      sliderDotsContainer = sliderContainer.find(`[class$="-slider-p-d-w"]`);
      sliderArrowsContainer = sliderContainer.find(`[class$="-slider-p-b-w"]`);
    }

    sliderDotsContainer.html("");
    sliderArrowsContainer.html("");

    let { prevArrow, nextArrow } = getSliderArrows();

    let sliderOptions = {
      autoplay: false,
      dots: true,
      appendDots: sliderDotsContainer,
      appendArrows: sliderArrowsContainer,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      slidesToShow: 3,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
          },
        },

        {
          breakpoint: 920,
          settings: {
            slidesToShow: 1,
          },
        },

        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          },
        },

        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    };

    sliderOptions = { ...sliderOptions, ...sliderOverrides };
    slider.slick(sliderOptions);

    // Animation
    // if (!sliderOverrides.autoplay) return false;
    handleSliderAnimation(sectionSelector, autoplay);
  });

  // Functions
  function getSliderArrows() {
    let prevArrow = `<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style="">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                  fill="#1A1A1A"
                  stroke="#1A1A1A"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M13.2602 15.53L9.74023 12L13.2602 8.46997"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </button>`,
      nextArrow = `<button class="slick-next slick-arrow" aria-label="Next" type="button" style="">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                  fill="#1A1A1A"
                  stroke="#1A1A1A"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M10.7402 15.53L14.2602 12L10.7402 8.46997"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </button>`;

    return { prevArrow, nextArrow };
  }

  function handleSliderAnimation(sectionSelector, autoplay) {
    var time = 7;
    var $bar, $slider, isPause, tick, percentTime;

    $slider = $(sectionSelector).find(`[class$="-slider"]`);

    if (!$slider.find(`.slick-initialized`).length) {
      setTimeout(() => handleSliderAnimation(sectionSelector), 100);
      return false;
    }

    $bar = getCurrentActiveDot($slider);
    if (!autoplay) {
      getCurrentActiveDot($slider).css({
        width: "100%",
      });
      return;
    }

    if (window.matchMedia(`(min-width: 768px)`).matches) {
      $slider.on({
        mouseenter: function () {
          isPause = true;
        },
        mouseleave: function () {
          isPause = false;
        },
      });
    }

    if ($slider.find(`.slick-arrow`).length == 0) {
      return false;
    }
    startProgressbar($slider);
    handleWhenArrowClicked($slider);

    function handleWhenArrowClicked(slider) {
      let arrows = slider.find(`.slick-arrow`);
      arrows.each(function () {
        arrows.on(`click`, function () {
          startProgressbar(slider);
        });
      });
    }

    function startProgressbar(slider) {
      resetProgressbar(slider);
      percentTime = 0;
      isPause = false;
      
      // Stop any existing animation frame
      if (tick) {
        cancelAnimationFrame(tick);
      }
      
      tick = requestAnimationFrame(() => interval(slider));
    }

    function interval(slider) {
      if (!slider.find(`.slick-slider`).length) {
        if (tick) {
            cancelAnimationFrame(tick);
        }
        return;
      }

      if (isPause === false) {
        percentTime += 1 / (time + 0.1);
        if(percentTime > 100) percentTime = 100;
        
        getCurrentActiveDot(slider).css({
          width: percentTime + "%",
        });

        if (percentTime >= 100) {
          slider.find(`.slick-initialized`).slick(`next`);
          startProgressbar(slider);
          return;
        }
      }
      
      tick = requestAnimationFrame(() => interval(slider));
    }

    function getCurrentActiveDot(slider) {
      return slider.find(`ul.slick-dots li.slick-active button`);
    }

    function resetProgressbar(slider) {
      getCurrentActiveDot(slider).css({
        width: 0 + "%",
      });
      
      if (tick) {
          cancelAnimationFrame(tick);
      }
    }
  }
}

function handlePlayStopVideoInCarousel(sectionSelector) {
  if (!$(`${sectionSelector} .slick-slide`).length) {
    setTimeout(function () {
      handlePlayStopVideoInCarousel(sectionSelector);
    }, 100);
    return false;
  }

  playOrStopVideo();

  $(`${sectionSelector} [class*="-slider-w"]`).on("afterChange", function (event, slick, currentSlide) {
    playOrStopVideo();
  });

  function playOrStopVideo() {
    $(`${sectionSelector} .slick-slide`).each(function () {
      let video = $(this).find(`video`)[0];
      let playButton = $(this).find(`[class$="-playBtn"] svg`);
      video.pause();
      video.volume = 0;
      video.controlsList = "nodownload";
      video.controls = false;
      if ($(this).hasClass(`slick-active`)) {
        video.play();
        // playButton.click();
      }
    });
  }

  // $(`.video-carousel-section video`).each(function() {

  $(document).on("click", `${sectionSelector} .slick-slide`, function (e) {
    e.preventDefault();
    e.stopPropagation();
    let video = $(this).find(`video`)[0];
    console.log("volume: ", video.volume);
    console.log("muted: ", video.muted);
    if (video.volume == 1) {
      video.muted = 1;
      video.volume = 0;
      video.controls = 0;
    } else {
      video.muted = 0;
      video.volume = 1;
      video.currentTime = 0;
      video.controls = 1;
    }

    // $(this).attr(`controls`, `true`);
  });

  // });
}
